import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getLocalStorage, setLocalStorage } from '@/utils/tools'
import { getMenuTree } from '@/pages/admins/menu/api'

const menuTreeCacheKey = 'cache-menu-tree'
const menuTreeCache = getLocalStorage(menuTreeCacheKey)

export const fetchGetMenuTreeAsync = createAsyncThunk(
  'menu/fetchGetMenuTreeAsync',
  () =>
    axios
      .get(getMenuTree(menuTreeCache?.version))
      .then((response) => {
        const resp = response?.data
        if (resp === null) return []
        if (resp.data === null && resp.version === menuTreeCache?.version) {
          return menuTreeCache.data ?? []
        } else {
          setLocalStorage(menuTreeCacheKey, resp)
          return resp.data ?? []
        }
      })
      .catch((err) => {
        throw Error('读取菜单缓存失败')
      })
)

const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    menuTree: [],
  },
  reducers: {
    setMenuTree(state, action) {
      state.menuTree = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetMenuTreeAsync.pending, (state) => {
        state.menuTree = []
      })
      .addCase(fetchGetMenuTreeAsync.fulfilled, (state, action) => {
        state.menuTree = action.payload
      })
  },
})

export const { setMenuTree } = menuSlice.actions
//获取所有部门树
export const getAllMenuTree = (state) => state.menu.menuTree
export default menuSlice.reducer
